import { FT_ASSETS_PATH, FT_ASSET_REQUEST_PATH } from "constants/request";
import { useCallback } from "react";
import { useRootSelector } from "store/hooks";

export const useAssets = () => {
  const { customerKey, idPId } = useRootSelector(
    (state) => state.config.client
  );

  const createAssetUrl = useCallback(
    (assetName: string) => {
      if (!!idPId) {
        return `${FT_ASSET_REQUEST_PATH}${idPId}/${assetName}#123`;
      } else {
        return `${FT_ASSET_REQUEST_PATH}by-customer-key/${customerKey}/${assetName}`;
      }
    },
    [customerKey, idPId]
  );

  const createDefaultAssetUrl = useCallback((assetName: string) => {
    return `${FT_ASSET_REQUEST_PATH}default/${assetName}`;
  }, []);

  const createTermsAndConditionsUrl = useCallback(() => {
    return `${FT_ASSETS_PATH}2023_TermsOfUse.pdf`;
  }, []);

  return {
    createAssetUrl,
    createDefaultAssetUrl,
    createTermsAndConditionsUrl,
  };
};
